import React, { useEffect, useState } from "react";
import { Box, Typography, Chip,Popover } from "@mui/material";
import { useTheme } from "../../ThemeContext";

const ClientCell = ({ clients }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { isDarkMode } = useTheme();

  if (!clients || clients.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: "text.secondary" }}
        >
          —
        </Typography>
      </Box>
    );
  }

  const maxVisible = 4;
  const visibleClients = clients.slice(0, maxVisible);
  const hiddenClients = clients.slice(maxVisible);
  const hiddenCount = clients.length - maxVisible;

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "nowrap",
        gap: 1,
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {visibleClients.map((client) => (
        <Chip
          key={client.user_id}
          label={client.name}
          variant="outlined"
          sx={{
            borderRadius: "16px",
            fontSize: "0.8rem",
            padding: "2px 6px",
            flexShrink: 0,
            backgroundColor: isDarkMode ? "rgba(0, 161, 135, 0.15)" : "#d9d9d9ff",
            color: isDarkMode ? "#e8f4f2ff" : "inherit",
            borderColor: isDarkMode ? "rgba(0, 161, 135, 0.5)" : "rgba(0, 0, 0, 0.23)",
            // boxShadow: isDarkMode ? "0 0 8px rgba(0, 161, 135, 0.2)" : "none",
            fontWeight: isDarkMode ? "600" : "inherit",
            transition: "all 0.2s ease-in-out",
          }}
        />
      ))}

      {hiddenCount > 0 && (
        <>
          <Chip
            label={`+${hiddenCount}`}
            variant="outlined"
            onClick={handleClick}
            sx={{
              borderRadius: "16px",
              fontSize: "0.8rem",
              fontWeight: "bold",
              padding: "2px 6px",
              flexShrink: 0,
              color: "rgba(2, 178, 152, 1)",
              borderColor: "rgba(2, 178, 152, 1)",
              backgroundColor: "transparent",
              cursor: "pointer",
            }}
          />

          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Box sx={{ p: 1.5 }}>
              {hiddenClients.map((client) => (
                <Typography key={client.user_id} variant="body2" sx={{ mb: 0.5 }}>
                  {client.name}
                </Typography>
              ))}
            </Box>
          </Popover>
        </>
      )}
    </Box>
  );
};



export default ClientCell;
